namespace Nobox.CRM {
    export interface TaskRow {
        Id?: number;
        Index?: number;
        BoardId?: number;
        ListId?: number;
        KategoriId?: number;
        IsDone?: number;
        Nama?: string;
        Ket?: string;
        Hasil?: string;
        Owner?: number;
        TnId?: number;
        DealId?: number;
        GroupId?: number;
        Tags?: string;
        Color?: string;
        KontakId?: number;
        KontakFoto?: string;
        KontakNama?: string;
        Lampiran?: string;
        Comments?: TaskcommentRow[];
        Mulai?: string;
        Selesai?: string;
        In?: string;
        Up?: string;
        InBy?: number;
        UpBy?: number;
        InByNm?: string;
        UpByNm?: string;
        ListNama?: string;
        ListIn?: string;
        ListUp?: string;
        ListInBy?: number;
        ListUpBy?: number;
        ShowBoard?: number;
    }

    export namespace TaskRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Nama';
        export const localTextPrefix = 'Nobox.Task';
        export const deletePermission = 'Tasks:Delete';
        export const insertPermission = 'Tasks:Modify';
        export const readPermission = 'Tasks:View';
        export const updatePermission = 'Tasks:Modify';

        export declare const enum Fields {
            Id = "Id",
            Index = "Index",
            BoardId = "BoardId",
            ListId = "ListId",
            KategoriId = "KategoriId",
            IsDone = "IsDone",
            Nama = "Nama",
            Ket = "Ket",
            Hasil = "Hasil",
            Owner = "Owner",
            TnId = "TnId",
            DealId = "DealId",
            GroupId = "GroupId",
            Tags = "Tags",
            Color = "Color",
            KontakId = "KontakId",
            KontakFoto = "KontakFoto",
            KontakNama = "KontakNama",
            Lampiran = "Lampiran",
            Comments = "Comments",
            Mulai = "Mulai",
            Selesai = "Selesai",
            In = "In",
            Up = "Up",
            InBy = "InBy",
            UpBy = "UpBy",
            InByNm = "InByNm",
            UpByNm = "UpByNm",
            ListNama = "ListNama",
            ListIn = "ListIn",
            ListUp = "ListUp",
            ListInBy = "ListInBy",
            ListUpBy = "ListUpBy",
            ShowBoard = "ShowBoard"
        }
    }
}
